(function ($) {
  "use strict";

  $(document).ready(init);

  function init() {
    onScrollAnimations();
    // navMobileCollapse();
    navMobile();
    sidebarMobileChangeIcon();
    carouselInitalize();
    identifyCurrentItemInMenu();
    // configureSearch();
    identifyCurrentItemInSidebar();

    if(hasUrlParameter('coupon')) addCouponToSigup();

    // fetch('//dashboard.back4app.com/me', {
    //   method: 'GET',
    //   credentials: 'include'
    // })
    // .then(function(response) {
    //   return response.json();
    // })
    // .then(function(data) {
    //   if(data.username) {
    //     window.location = 'https://dashboard.back4app.com/apps/#!/admin';
    //   }
    // });

  }

  function onScrollAnimations() {
    $('.wp-1').waypoint(function() {
      $('.wp-1').addClass('animated fadeInUp');
    }, {
      offset: '75%'
    });
    $('.wp-2').waypoint(function() {
      $('.wp-2').addClass('animated fadeInUp');
    }, {
      offset: '75%'
    });
    $('.wp-3').waypoint(function() {
      $('.wp-3').addClass('animated fadeInUp');
    }, {
      offset: '75%'
    });
    $('.wp-4').waypoint(function() {
      $('.wp-4').addClass('animated fadeIn');
    }, {
      offset: '75%'
    });
    $('.wp-5').waypoint(function() {
      $('.wp-5').addClass('animated fadeInRight');
    }, {
      offset: '50%'
    });
    $('.wp-6').waypoint(function() {
      $('.wp-6').addClass('animated fadeInLeft');
    }, {
      offset: '50%'
    });
    $('.wp-7').waypoint(function() {
      $('.wp-7').addClass('animated fadeInUp');
    }, {
      offset: '60%'
    });
    $('.wp-8').waypoint(function() {
      $('.wp-8').addClass('animated fadeInUp');
    }, {
      offset: '60%'
    });
  }

  // function navMobileCollapse() {
  //   // avoid having both mobile navs opened at the same time
  //   $('#collapsingMobileUser').on('show.bs.collapse', function () {
  //     $('#collapsingNavbar').removeClass('in');
  //     $('[data-target="#collapsingNavbar"]').attr('aria-expanded', 'false');
  //   });
  //   $('#collapsingNavbar').on('show.bs.collapse', function () {
  //     $('#collapsingMobileUser').removeClass('in');
  //     $('[data-target="#collapsingMobileUser"]').attr('aria-expanded', 'false');
  //   });
  //
  //   // dark navbar
  //   $('#collapsingMobileUserInverse').on('show.bs.collapse', function () {
  //     $('#collapsingNavbarInverse').removeClass('in');
  //     $('[data-target="#collapsingNavbarInverse"]').attr('aria-expanded', 'false');
  //   });
  //   $('#collapsingNavbarInverse').on('show.bs.collapse', function () {
  //     $('#collapsingMobileUserInverse').removeClass('in');
  //     $('[data-target="#collapsingMobileUserInverse"]').attr('aria-expanded', 'false');
  //   });
  // }

  function navMobile() {
    $('.hamburger').bind('click', function() {
      $('.sidebar').addClass('open');
    });

    $('.sidebar-outside').bind('click', function() {
      $('.sidebar').removeClass("open");
    });

    $( window ).resize(function() {
      var w = $(window).width();
      if(w > 1100) $('.sidebar').removeClass("open");
    });
  }

  function sidebarMobileChangeIcon() {
    $('.link').bind('click', function() {
      // Change sidebar menu icon plus and minus
      var icon = $(this).find('i')[0];

      if($(icon).hasClass('zmdi-plus-square')) {
        $(icon).removeClass('zmdi-plus-square');
        $(icon).addClass('zmdi-minus-square');
      }
      else if($(icon).hasClass('zmdi-minus-square')) {
        $(icon).removeClass('zmdi-minus-square');
        $(icon).addClass('zmdi-plus-square');
      }
    });
  }

  function identifyCurrentItemInSidebar() {
    var currentUrl = window.location.href;

    $('.sidebar .menu a').each(function () {
      if(currentUrl === this.href) {
        $(this)
        .addClass('active');

        // $(this)
        // .closest('.collapse')
        // .siblings('.menu-item-header')
        // .find('a')
        // .addClass('active');

        $(this)
        .closest('.collapse')
        .addClass('in');

        var icon = $(this)
        .closest('.collapse')
        .siblings('.menu-item-header')
        .find('.link')
        .find('i');

        $(icon).removeClass('zmdi-plus-square');
        $(icon).addClass('zmdi-minus-square');

        $(this)
        .siblings('.icon-caret')
        .show();
      }
    });
  }

  function carouselInitalize() {
    $('.carousel').carousel({
  		interval: 3000
  	});
  }

  function identifyCurrentItemInMenu() {
    var currentUrl = window.location.href;
    $('.header-bar > .menu a').each(function() {
      if(currentUrl === this.href) {
        $(this)
        .addClass('active');
        $(this)
        .closest('li')
        .addClass('active');
      }
    });

    // $('.active').closest('li.dropdown').addClass('active');
  }

  function configureSearch() {

    $('.search-button').bind('click', function(event) {

      $('.search').css({top: 30});

      $('.search-button').hide();

      $('.input-search')
      .show()
      .focus()
      .focusout(function() {
        $(this).hide();
        $('.search-button').show();
        $('.menu').show();
        $('.face').show();
      });

      var screenWidth = $(window).width();

      if(screenWidth < 760) {
        $('.menu').hide();
        $('.brand').hide();
      }

      if(screenWidth < 620) {
        $('.face').hide();
      }

    });
  }

  function hasUrlParameter(name) {
    return !!getUrlParameter(name);
  }

  function addCouponToSigup() {
    var coupon = getUrlParameter('coupon');
    $('[name=event]')[0].value = coupon;
    $('[name=event]')[1].value = coupon;
    $('#site-signup-form')[0].action += '/events';
    $('#site-signup-form-modal')[0].action += '/events';
  }

  function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  };

  $('.search-button').focus();

})(jQuery);
